import { textInput } from 'constants/fonts';

export default {
  modalContent: {
    padding: '20px 30px 0px'
  },
  textInputSize: {
    fontSize: textInput
  }
};
